import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';

const GET_CAR = 'carInfo/GET_CAR';
export const getCar = createAction(GET_CAR, api.getCar);

const GET_CAR_SIMPLE = 'carInfo/GET_CAR_SIMPLE';
export const getCarSimple = createAction(GET_CAR_SIMPLE, api.getCarSimple);

const GET_PHOTO = 'carInfo/GET_PHOTO';
export const getPhoto = createAction(GET_PHOTO, api.getPhoto);

const GET_DIAGNOSIS = 'carInfo/GET_DIAGNOSIS';
export const getDiagnosis = createAction(GET_DIAGNOSIS, api.getDiagnosis);

const GET_INSPECT = 'carInfo/GET_INSPECT';
export const getInspect = createAction(GET_INSPECT, api.getInspect);

const GET_CAR_DUE_DATE = 'carInfo/GET_CAR_DUE_DATE';
export const getCarDueDate = createAction(GET_CAR_DUE_DATE, api.getCarDueDate);

const GET_ESTIMATE = 'carInfo/GET_ESTIMATE';
export const getEstimate = createAction(GET_ESTIMATE, api.getEstimate);

const GET_CAR_RE_REGIST = 'carInfo/GET_CAR_RE_REGIST';
export const getCarReregist = createAction(GET_CAR_RE_REGIST, api.getCarReregist);

const initialState = {
	car: {},
	carSimple: undefined,
	photo: [],
	diagnosis: {},
	inspect: {},
	estimate: {},
	reregist: {},
};

export default handleActions(
	{
		...pender({
			// 데이터 없을 경우 204 No Content
			type: GET_CAR,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const car = data === '' ? {} : data[0];
					draft.car = car || {};
				}),
		}),

		...pender({
			// 데이터 없을 경우 204 No Content
			type: GET_CAR_SIMPLE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.carSimple = data || {};
				}),
		}),

		...pender({
			// 데이터 없을 경우 204 No Content
			type: GET_PHOTO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const photos = data === '' ? [] : data.carPhotoInfoList;
					draft.photo = photos || [];
				}),
		}),

		...pender({
			// 데이터 없을 경우 204 No Content
			type: GET_DIAGNOSIS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const diagnosis = data === '' ? {} : data;
					draft.diagnosis = diagnosis || {};
				}),
		}),

		...pender({
			// 데이터 없을 경우 204 No Content
			type: GET_INSPECT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.inspect = data || {};
				}),
			onFailure: (state, action) =>
				produce(state, (draft) => {
					draft.inspect = action || {};
				}),
		}),

		...pender({
			type: GET_CAR_DUE_DATE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.dueDate = data.dueDate;
				}),
		}),

		...pender({
			type: GET_ESTIMATE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.estimate = data || {};
				}),
		}),

		...pender({
			type: GET_CAR_RE_REGIST,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const reregist = data === '' ? {} : data.result[0];
					draft.reregist = reregist || {};
				}),
		}),
	},
	initialState,
);
